import React from 'react'
import { Box } from '@material-ui/core'
import { Input } from 'Components/Form/Input'
import { SelectDashboard } from 'Components/Form/SelectDashboard'
import { PAYMENT_SYSTEM_TYPES_ENUM } from '../../shared/constants'

const PaymentSystemSelector = props => {
  const { paymentState, onChange } = props

  return (
    <div>
      <Box display="flex" mt={3}>
        <Box width={700} mr={5}>
          <SelectDashboard
            label="Payment System"
            options={[
              {
                label: 'Per Mission',
                value: PAYMENT_SYSTEM_TYPES_ENUM.PER_MISSION,
              },
              {
                label: 'Per Hour',
                value: PAYMENT_SYSTEM_TYPES_ENUM.PER_HOUR,
              },
            ]}
            value={paymentState.paymentSystem}
            onChange={(a, b, value) => onChange('paymentSystem', value)}
            name="citySelect"
          />
        </Box>
      </Box>
      <br />
      <Box display="flex" mt={3}>
        <Box width={700} mr={5}>
          {paymentState.paymentSystem ==
            PAYMENT_SYSTEM_TYPES_ENUM.PER_MISSION && (
            <Input
              className={`input-with-icon`}
              placeholder="Distribution Cost"
              type="number"
              label="Approximate Distribution Cost for Customer"
              value={paymentState.distributionCost}
              onChange={e =>
                onChange('distributionCost', Number(e.target.value))
              }
              error="* This value is purely for the calculation and will not be saved"
            />
          )}
          {paymentState.paymentSystem == PAYMENT_SYSTEM_TYPES_ENUM.PER_HOUR && (
            <div>
              <Input
                className={`input-with-icon`}
                placeholder="Hourly Payout"
                type="number"
                label="Hourly Payout"
                value={paymentState.hourlyPayout}
                onChange={e => onChange('hourlyPayout', Number(e.target.value))}
                error="* This value is purely for the calculation and will not be saved"
              />
              <br />
              <Input
                className={`input-with-icon`}
                placeholder="Client Margin Percent"
                type="number"
                label="Client Margin Percent"
                value={paymentState.clientMarginPercent}
                onChange={e =>
                  onChange('clientMarginPercent', Number(e.target.value))
                }
                error="* This value is purely for the calculation and will not be saved"
              />
            </div>
          )}
        </Box>
      </Box>
    </div>
  )
}

export default PaymentSystemSelector



// WEBPACK FOOTER //
// ./src/Components/PaymentSystemSelector/index.js